import React, {useState,useEffect} from "react";
import { Container, Row, Col } from "react-bootstrap";
import HeaderComponent from "./HeaderComponent";
import FooterComponent from "./FooterComponent";
import PropTypes from 'prop-types';




const LayoutComponent = ({children, tab, updateTab}) => {
     switch(tab){
        case '/Demo':
            return(
                <React.Fragment>
                    <main>{children}</main>
                </React.Fragment>
            )
        case '/AdminDemo':
            return(
                <React.Fragment>
                    <main>{children}</main>
                </React.Fragment>
            )
        default:
            return(
                <React.Fragment>
                    <HeaderComponent tab={tab} updateTab={updateTab}/>
                    <main>{children}</main>
                    <FooterComponent/>
                </React.Fragment>
            );
     }
    
   
}

LayoutComponent.defaultProps = {

}
LayoutComponent.propTypes = {
/** State Props */
tab: PropTypes.string,
updateTab:PropTypes.func,
}

export default (LayoutComponent);